import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {NavItem} from '../../api-dependencies/api-dependency-menu/api-dependency-menu.component';
import {animate, state, style, transition, trigger} from '@angular/animations';

export interface NavItem {
    displayName: string;
    disabled?: boolean;
    iconName: string;
    type: string;
    api: any;
    index: number;
    children?: NavItem[];
}

@Component({
    selector: 'app-dependency',
    templateUrl: './dependency.component.html',
    styleUrls: ['./dependency.component.scss'],
    animations: [
        trigger('indicatorRotate', [
            state('collapsed', style({transform: 'rotate(0deg)'})),
            state('expanded', style({transform: 'rotate(180deg)'})),
            transition('expanded <=> collapsed',
                animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
            ),
        ])
    ]
})
export class DependencyComponent implements OnInit {

    @Input() expanded: boolean;
    @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
    @Input() item: any;
    @Input() depth: number;
    @Input() expandChildren = false;
    @Input() isParent = false;
    @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output() allCompleted: EventEmitter<any> = new EventEmitter<any>();
    @Output() showLogs: EventEmitter<any> = new EventEmitter<any>();


    // constructor(public navService: NavService,
    //             public router: Router) {
    //   if (this.depth === undefined) {
    //     this.depth = 0;
    //   }
    // }

    constructor(public router: Router) {
        if (this.depth === undefined) {
            this.depth = 0;
        }
        this.ariaExpanded = this.expanded;
    }

    ngOnInit() {
        // this.navService.currentUrl.subscribe((url: string) => {
        //   if (this.item.route && url) {
        //     // console.log(`Checking '/${this.item.route}' against '${url}'`);
        //     this.expanded = url.indexOf(`/${this.item.route}`) === 0;
        //     this.ariaExpanded = this.expanded;
        //     // console.log(`${this.item.route} is expanded: ${this.expanded}`);
        //   }
        // });
    }

    // ngOnChanges(changes: SimpleChanges) {
    //     for (const propName in changes) {
    //         if (propName === 'apiDeploymentStatus') {
    //             console.log(this.apiDeploymentStatus);
    //         }
    //     }
    // }

    onItemSelected(index) {
        // if (!item.children || !item.children.length) {
        //   this.router.navigate([item.route]);
        //   this.navService.closeNav();
        // }
        this.itemSelected.emit(index);
    }

    toggleItem(item) {
        if (item.children && item.children.length) {
            this.expanded = !this.expanded;
        }
    }

    expandAll() {
        this.expanded = true;
        this.expandChildren = true;
    }

    collapseAll() {
        this.expanded = false;
        this.expandChildren = false;
    }

    updateAllComplete(itemObj) {
        this.allCompleted.emit(itemObj);
    }

    showLog(val) {
        this.showLogs.emit(val);
    }

}
